import * as React from 'react';
import { ButtonGroup } from '../ButtonGroup';
/**
 * Компонент выполняет функцию адаптера над ButtonGroup
 * Реализация ButtonGroup может измениться или переехать в ui-kit.
 * Компонент FilterWithButtonGroup помогает совместить общий интерфейс фильтров к интерфейсу кнопок
 * */

import { jsx as _jsx } from "react/jsx-runtime";
export function FilterWithButtonGroup(props) {
  var value = props.value,
      values = props.values,
      onValueChange = props.onValueChange,
      testId = props.testId;
  return /*#__PURE__*/_jsx(ButtonGroup, {
    testId: testId,
    currentActiveValue: value,
    buttons: values,
    onChange: onValueChange,
    fullWidth: true
  });
}